import React, { useState, useEffect } from 'react';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import LeftSide from './Components/LeftSide/LeftSide';
import Main from './Components/Main/Main';
import Matrix from './Components/Matrix/Matrix';
import './App.css';



const App = () => {

  const [activeScreen, setActiveScreen] = useState("home");
  const contents = ['Home', "Biography", "Works", "Service", "Schedule", "SNS", "Contact"];
  const [isOpen, setIsOpen] = useState(false);
  const windowWidth = window.innerWidth;

  useEffect(() => {
    if (windowWidth <= 991) {
      setIsOpen(true);
      console.log(isOpen);
    }

  }, [windowWidth]);




  const toggleSlider = () => {
    setIsOpen(!isOpen);
    console.log("toggle" + isOpen);
  }

  return (
    <div className="App">
      <Matrix />
      <div className="app__screen-wrapper">
        <div className="header-wrapper">
          <Header className="header" />
          <div className="header-border"></div>
        </div>
        <div className="center-wrapper">
          <div className={isOpen ? "left-side-open" : "left-side-close"}>
            <div className="left-side-wrapper">
              <div onClick={toggleSlider} className="leftside-button hoverable">
                {isOpen ? ">>" : "<<"}
              </div>
              <div
                className={!isOpen ? "toggle-flex" : "toggle-none"}
                onClick={toggleSlider}>
                MENU&gt;&gt;
              </div>
              <LeftSide
                contents={contents}
                setActiveScreen={setActiveScreen}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                className="left-side-contents" />

            </div>

          </div>
          <div className="main-wrapper">

            <Main activeScreen={activeScreen} setActiveScreen={setActiveScreen} className="main-contents" />

          </div>
        </div>
        <div className="footer-wrapper">
          <div className="footer-border">

          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default App;
